import { render, staticRenderFns } from "./TagEditModal.vue?vue&type=template&id=e793ff90&scoped=true&"
import script from "./TagEditModal.vue?vue&type=script&lang=js&"
export * from "./TagEditModal.vue?vue&type=script&lang=js&"
import style0 from "./TagEditModal.vue?vue&type=style&index=0&id=e793ff90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e793ff90",
  null
  
)

export default component.exports